import { Component, Input, OnInit } from '@angular/core';
import { TabNavLinks } from './tab-nav-links';

@Component({
  selector: 'db-tab-nav',
  templateUrl: './tab-nav.component.html',
  styleUrls: ['./tab-nav.component.scss']
})
export class TabNavComponent implements OnInit {
  @Input() navLinks: TabNavLinks[];
  @Input() adminNavLinks: TabNavLinks[];

  constructor() { }

  ngOnInit() {
  }

}
